var EHDI = EHDI || Object.create(null);


EHDI.scene.GameScene = function() {
    EHDI.aka.Container.call(this);
    var isOver = false;
    this.hasShuffled = false;
    

}

EHDI.scene.GameScene.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.scene.GameScene.prototype.initProps = function() {

}

EHDI.scene.GameScene.prototype.initGraphics = function() {
    EHDI.GAME.gameScene = this;
    EHDI.scene.GameScene.timer = new EHDI.components.Timer();
        if(EHDI.GAME.constants.customTimeLimit) {
            EHDI.scene.GameScene.timer.timeLeft =EHDI.GAME.constants.customTimeLimit / 1000;
        } else {
            EHDI.scene.GameScene.timer.timeLeft =EHDI.GAME.constants.gametimelimit / 1000;
        }
        EHDI.scene.GameScene.timer.x =  280;
        EHDI.scene.GameScene.timer.y =  5;
    EHDI.GAME.pauseButton = new EHDI.components.pauseButton();

    var foreground = new EHDI.aka.Sprite(EHDI.Assets.images["am_rock_base"]);
    this.addChild(foreground);
    
    foreground.anchor.set(0.5, 1);
    foreground.position.set(EHDI.screen.stageWidth * 0.5, EHDI.screen.stageHeight);
    
    EHDI.scene.GameScene.shapeManager = new EHDI.components.ShapeManager();
    this.addChild(EHDI.scene.GameScene.shapeManager);
    this.scoreHolder = EHDI.components.ScoreManager(this);
    this.scoreHolder.setXY(10,5);
    this.addChild(EHDI.scene.GameScene.timer);
    this.addChild(EHDI.GAME.pauseButton);

     this.closeBtn = new EHDI.displays.Button(EHDI.Assets.images["btn_close"], null, null, null,0.8);
      this.closeBtn.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.95, EHDI.GAME.sceneManager.getStageHeight() * 0.075);
      this.closeBtn.setOnClickFunction(function(){
        callFlexFunction()
      });
      this.addChild(this.closeBtn);
    
    var shuffle = function() {
        EHDI.GAME.soundManager.playSFX("button_sfx");
        EHDI.GAME.gameScene.shuffleButton.visible = false;
        EHDI.GAME.gameScene.hasShuffled = true;
        EHDI.scene.GameScene.shapeManager.shuffle();
    }
    
    this.shuffleButton = new EHDI.displays.Button(EHDI.Assets.images["cm_ui_shufflebtn"], EHDI.Assets.images["cm_ui_shufflebtn_pressed"], null, null);
    this.shuffleButton.setOnClickFunction(shuffle);
    this.shuffleButton.position.set(EHDI.screen.stageWidth * 0.7, EHDI.screen.stageHeight * 0.075);
    this.addChild(this.shuffleButton);
    
    var shuffleTxt = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("BTN_SHUFFLE")); 
    
    shuffleTxt.anchor.set(0.5, 0.5);
    
    this.shuffleButton.addChild(shuffleTxt);

    
    this.leftArrow = new EHDI.displays.Button(EHDI.Assets.images["btn_arrow"], null, null, null, 0.8);
    this.leftArrow.setOnClickFunction(EHDI.scene.GameScene.shapeManager.rotateAllCW.bind(EHDI.scene.GameScene.shapeManager));
    this.leftArrow.customScale = {x : -0.8, y : 0.8};
    this.leftArrow.baseScale = {x : -1, y : 1};
    this.leftArrow.scale.x = -1;
    this.leftArrow.position.set(EHDI.screen.stageWidth * 0.15, EHDI.screen.stageHeight * 0.8);
    this.addChild(this.leftArrow);
    
    this.rightArrow = new EHDI.displays.Button(EHDI.Assets.images["btn_arrow"], null, null, null, 0.8);
    this.rightArrow.setOnClickFunction(EHDI.scene.GameScene.shapeManager.rotateAllCCW.bind(EHDI.scene.GameScene.shapeManager));
    this.rightArrow.position.set(EHDI.screen.stageWidth * 0.85, EHDI.screen.stageHeight * 0.8);
    this.addChild(this.rightArrow);
}


EHDI.scene.GameScene.prototype.initListeners = function() {
    
    this.gameOver = function()
    {
        var score = EHDI.GAME.gameScene.scoreHolder.getScore();

        var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);
        if(score > cache.highScore) {
            EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.id, cache);
            cache.highScore = score;
        }

        if(EHDI.GAME.constants.gameEndFunction) {
            EHDI.GAME.soundManager.autoResumeToggle(true);
            EHDI.GAME.pauseButton.endGame();
            EHDI.GAME.constants.gameEndFunction(EHDI.GAME.constants.gameName, EHDI.GAME.gameScene.scoreHolder.getScore());   
        } else {
            var star = 0;
            if(score > 0 && score < 750) {
                star = 1;
            } else if (score >= 750 && score < 1500) {
                star = 2;
            } else if (score >= 1500) {
                star = 3;
            }
     
            EHDI.GAME.soundManager.playSFX("score_points"); //error like sound
            EHDI.GAME.soundManager.autoResumeToggle(true);
            EHDI.GAME.pauseButton.endGame();
            EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PostGamePopUp(star, score), {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(), EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});
        }

        /*if(isOver)
            return;
        var score = EHDI.GAME.gameScene.scoreHolder.getScore();
        var star = 0;
        if(score > 0 && score < 750) {
            star = 1;
        } else if (score >= 750 && score < 1500) {
            star = 2;
        } else if (score >= 1500) {
            star = 3;
        }

        isOver = true;        
        EHDI.GAME.soundManager.playSFX("score_points"); //error like sound
        EHDI.GAME.soundManager.autoResumeToggle(true);
        EHDI.GAME.pauseButton.endGame();
        EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PostGamePopUp(star, score), {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(), EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});*/
    }
    
    EHDI.scene.GameScene.timer.onTimerDone = this.gameOver;
    
    EHDI.GAME.soundManager.autoResumeToggle(false);
}

EHDI.scene.GameScene.prototype.killGraphics = function() {
    this.rightArrow.destroy();
    this.rightArrow = null;

    this.leftArrow.destroy();
    this.leftArrow = null;

    this.shuffleButton.destroy();
    this.shuffleButton = null;

     if(this.scoreHolder != null)
    {   
        this.scoreHolder.dispose();
    }
    delete this.scoreHolder;

    if(this.closeBtn != null)
        {
            this.removeChild(this.closeBtn);
            this.closeBtn.dispose();
        }
      delete this.closeBtn;

    EHDI.scene.GameScene.shapeManager.destroy();
    EHDI.scene.GameScene.shapeManager = null;

    EHDI.scene.GameScene.timer.dispose();
    EHDI.scene.GameScene.timer.destroy();
    EHDI.scene.GameScene.timer = null;

    EHDI.GAME.pauseButton.destroy();
    EHDI.GAME.pauseButton = null;
}

EHDI.scene.GameScene.prototype.screenWillAppear = function() {
    var bg = new EHDI.aka.Sprite(EHDI.Assets.images["am_bg"]);
    this.addChild(bg);

    this.initProps();
    this.initGraphics();
    this.initListeners();
    
};

EHDI.scene.GameScene.prototype.screenDidAppear = function() { 
    var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);
    if(cache.isFirstTimePlay || EHDI.GAME.constants.htpShow)
    {    
        cache.isFirstTimePlay = false;   
        EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.id, cache);
        EHDI.GAME.pauseButton.isPaused = true;
        EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PausePopUp(), {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(), EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});
    }
};

EHDI.scene.GameScene.prototype.restart = function() {
    this.killGraphics();

    this.initProps();
    this.initGraphics();
    this.initListeners();
}

EHDI.scene.GameScene.prototype.dispose = function() {
    this.killGraphics();
}


EHDI.scene.GameScene.prototype.screenDidDisappear = function() {
    this.killGraphics();
}

